import { Component, inject } from '@angular/core';
import { DynamicPageDcBaseComponent } from '../dynamic-page-dc-base/dynamic-page-dc-base.component';
import { CommonModalService, generateId, S3UploadService } from 'gung-common';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'lib-dynamic-page-dc-video',
  standalone: false,
  templateUrl: './dynamic-page-dc-video.component.html',
  styleUrl: './dynamic-page-dc-video.component.scss'
})
export class DynamicPageDcVideoComponent extends DynamicPageDcBaseComponent {
  protected s3UploadService = inject(S3UploadService);
  protected modalService = inject(CommonModalService);

  idUploadInput = generateId();

  elementId = 'video';
  fields = {
    videoUrl: null,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    height: 400,
    responsive: true,
    autoplay: false,
    controls: true,
    muted: false,
    loop: false,
    backgroundColor: null
  };

  uploadVideo() {
    const fn = async (files: File[]) => {
      return await firstValueFrom(this.s3UploadService.postDocument(files[0]));
    };
    this.modalService
      .openUploadModalComponent(fn, true, true, 'video/mp4, video/webm, video/ogg', {
        translateTag: 'UPLOAD_VIDEO',
        class: 'mb-2 text-center'
      })
      .then(res => {
        if (res) {
          this.element.fields.videoUrl = `https://cdn2.gung.io/${res.s3Uri}`;
        }
      });
  }
}
